<template>
	<div class="goods">
		<v-head :title="title"></v-head>
		<div class="content">
		<p>注：支付凭证 <span>* ( 只能上传jpg/png文件，且不超过500kb )</span></p>
		<van-uploader
		  v-model="fileList"
		  multiple
		  :max-count="1"
		  :after-read="afterRead"
		/>
	</div>
</div>
</template>

<script type="text/javascript">
import vHead from "../../components/Subhead.vue";	

import { mapState } from "vuex";
import { Uploader,Toast} from "vant";
import {
	underLineSubmit,
	underLineSubmitMeeting
} from "@/api/dictionary";
export default {
  data() {
    return {
      fileList: [],
		commentImg:[],
		title:"支付凭证"
    }
  },
    components: {
    vHead,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,

  },
    methods: {
		afterRead(item){
			/*return file=>{
				let query = {
					file:item
				}
				this.comment.uploadImg(query).then(res=>{
					if(res.ok==true){
						if(this.commentImg.length>4){
							this.Toast("mei")
							return
						}
						this.commentImg.push(res.data);
					}
				})
			}*/
			let params = new FormData();
			params.append("file", item.file);
			params.append("memberId",this.userInfo.id);
			params.append("orderId",this.orderId);
			params.append("memberCategory",this.userInfo.memberCategory);
			if(this.from == 'member'){
				underLineSubmit(params).then(res => {
					if (res.success) {
						this.titleFileId = res.result.id;
						Toast("上传成功");
						this.$router.push({ name: 'PaymentList'});
					} else {
						Toast("上传失败");
					}
				});
			}else if(this.from == 'meeting'){
				underLineSubmitMeeting(params).then(res => {
				if (res.success) {
					this.titleFileId = res.result.id;
					Toast("上传成功");
					 this.$router.push({ name: 'payMeeting'});
				} else {
					Toast("上传失败");
				}
			});
			}


		},
  },
computed:{
  	orderId(){
  		return this.$route.query&&this.$route.query.orderId;
	},
	from(){
  		return this.$route.query&&this.$route.query.from;
	},
	...mapState(["userInfo"])
}
};
</script>

<style type="text/css" lang="less" scoped>
/deep/.van-nav-bar .van-icon{
  color: #fff;
}
.content{ 
    padding:20px;
  p{ 
  	font-size: 14px; color: #000; margin:10px 0; margin-bottom: 20px;
   span{ color: #d64a4a; font-size: 12px; }
  }
}
/deep/.van-ellipsis{ display: inline-block; line-height: 50px;color: #dfdfdf;}
/deep/.van-nav-bar__text{color: #dfdfdf;}
</style>